/**
 * ListBox component that renders a listbox with children as options.
 *
 * @param {Object} props - The properties to configure the Dropdown component.
 * @param {ReactNode} props.children - The options to be rendered within the dropdown.
 * @return {ReactElement} - The rendered dropdown component.
 */
export default function ListBox({children}) {
	return (
		<div
			role="listbox"
			className="
			dxp-absolute
			dxp-bg-white
			dxp-border-b
			dxp-border-gray-200
			dxp-border-l
			dxp-border-r
			dxp-left-0
			dxp-right-0
			dxp-shadow-black/[.08]
			dxp-shadow-md
			dxp-top-full
			dxp-overflow-auto
			dxp-max-h-80
			dxp-rounded-b-md
			dxp-z-10
			"
		>
			{children}
		</div>
	);
}
